import { PublicKey, TransactionInstruction } from "@solana/web3.js";
import { ReferralProgram } from "../type";

export interface ICloseEscrowParams {
  referralProgram: ReferralProgram;
  escrowAddress: PublicKey;
  stakingAddress: PublicKey;
  owner: PublicKey;
  rentReceiver: PublicKey;
  skipCloseIfNonEmpty: boolean;
}

export async function createCloseEscrowIx(
  params: ICloseEscrowParams,
): Promise<TransactionInstruction> {
  const {
    referralProgram,
    escrowAddress,
    stakingAddress,
    owner,
    rentReceiver,
    skipCloseIfNonEmpty,
  } = params;

  return referralProgram.methods
    .closeEscrow(skipCloseIfNonEmpty)
    .accountsPartial({
      escrow: escrowAddress,
      staking: stakingAddress,
      owner,
      rentReceiver,
    })
    .instruction();
}
